import type { Task } from '@/type';

import type { TaskFrameInfo } from '../type';

export const getTaskFrameInfo = (
  task: Task,
  assignedUserCount?: number,
): TaskFrameInfo => {
  const startFrameSeq = task.startFrameSeq || 1;
  const endFrameSeq =
    startFrameSeq + task.workFrameInterval * (task.fullFrameCount - 1);
  const userTaskCount = task.userTask?.length ?? 1;
  const fullFrameCount = task.fullFrameCount;

  const effectiveUserCount = assignedUserCount ?? userTaskCount;
  const userMoreOrEqualThanFrame = effectiveUserCount >= fullFrameCount;
  const allocateRangeGap = Math.floor(fullFrameCount / effectiveUserCount);

  return {
    startFrameSeq,
    endFrameSeq,
    userTaskCount,
    fullFrameCount,
    userMoreOrEqualThanFrame,
    allocateRangeGap,
  };
};
